import styled from 'styled-components';
import { ThumbnailScroller } from 'styles';

export const Base = styled(ThumbnailScroller)`
	padding: 8px 8px 0;
`;
